interface GoogleConfig {
  API_KEY: string;
  CLIENT_ID: string;
  SECRET: string;
}

interface FacebookConfig {
  APP_ID: string;
}

interface ApiConfig {
  API_URL: string;
}

interface AsaasConfig {
  encryptionScriptUrl: string;
}

interface PaddleConfig {
  clientToken: string;
  env: "sandbox" | "production";
}

interface Config {
  google: GoogleConfig;
  facebook: FacebookConfig;
  api: ApiConfig;
  asaas: AsaasConfig;
  paddle: PaddleConfig;
}

const asaasSaasEnv =
  process.env.REACT_APP_ASAAS_SAAS_ENV ||
  process.env.REACT_APP_ADATIS_SAAS_ASAAS_ENV ||
  "sandbox";

const paddleEnvNormalized =
  (process.env.REACT_APP_ADATIS_SAAS_PADDLE_ENV || "sandbox").toLowerCase() ===
  "production"
    ? "production"
    : "sandbox";

/** Local Docker serves plain HTTP on :8000 — HTTPS localhost has no cert and breaks login. */
const resolveApiUrl = (): string => {
  const raw = process.env.REACT_APP_API_URL || "http://localhost:8000/api/v1";
  if (/^https:\/\/localhost(?::\d+)?(?:\/|$)/i.test(raw)) {
    return raw.replace(/^https:/i, "http:");
  }
  return raw;
};

const config: Config = {
  google: {
    API_KEY: "",
    CLIENT_ID: "",
    SECRET: "",
  },
  facebook: {
    APP_ID: "",
  },
  api: {
    API_URL: resolveApiUrl(),
  },
  asaas: {
    encryptionScriptUrl:
      process.env.REACT_APP_ASAAS_ENCRYPTION_SCRIPT_URL ||
      (asaasSaasEnv === "production"
        ? "https://www.asaas.com/asaas-encryption.js"
        : "https://sandbox.asaas.com/asaas-encryption.js"),
  },
  paddle: {
    clientToken: process.env.REACT_APP_ADATIS_SAAS_PADDLE_CLIENT_TOKEN || "",
    env: paddleEnvNormalized,
  },
};

export default config;